import { useContext, useEffect, useState, useCallback } from "react";
import { Context } from "../Context/GlobalContext";
import { Woo } from "../../Helpers/Woo";

export const useCustomerAddresses = () => {
  const { user } = useContext(Context);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const token = user?.access_token;

  const fetchAddresses = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const res = await Woo.customers.shippingAddresses.all(token);
      if (res.code === 200) {
        setAddresses(res.data);
      }
    } catch (e) {
      setError("Error al cargar direcciones");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  const addAddress = useCallback(async (address) => {
    if (!token) return null;
    setLoading(true);
    setError(null);
    try {
      const res = await Woo.customers.shippingAddresses.post(token, address);
      if (res.code === 200) {
        setAddresses(res.data);
        return res.data;
      } else {
        setError(res.error || "Error al guardar la dirección");
        return null;
      }
    } catch (e) {
      setError("Error al guardar la dirección");
      return null;
    } finally {
      setLoading(false);
    }
  }, [token]);

  const deleteAddress = useCallback(async (id) => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const res = await Woo.customers.shippingAddresses.delete(token, id);
      if (res.code === 200) {
        setAddresses(res.data);
        if (selectedAddress?.id === id) {
          setSelectedAddress(null);
        }
      }
    } catch (e) {
      setError("Error al eliminar la dirección");
    } finally {
      setLoading(false);
    }
  }, [token, selectedAddress]);

  const selectAddress = useCallback((address) => {
    setSelectedAddress(address);
  }, []);

  const clearAddress = useCallback(() => {
    setSelectedAddress(null);
  }, []);

  return {
    addresses,
    loading,
    error,
    addAddress,
    deleteAddress,
    selectedAddress,
    selectAddress,
    clearAddress,
  };
};
